<template>
  <div class="tableDiv-txt" data-order-activity-summary>
    <span v-if="failed && field !== 'payCompositionText'" class="activity-read-failed">活动信息读取失败</span>
    <template v-else-if="field === 'activityPayModeName'">
      <span>{{ modeText }}</span>
      <span v-if="row.payStageName">支付阶段:{{ row.payStageName }}</span>
      <span v-if="row.isCashOnlyGoods" class="cash-only-txt">含只支持现金的商品</span>
    </template>
    <span v-else-if="field === 'payCompositionText'">{{ row.payCompositionText || '支付构成未记录' }}</span>
    <template v-else-if="field === 'activityTagList'">
      <span v-for="(tag,index) in tags" :key="index">{{ tag }}</span>
      <span v-if="ruleIds.length" class="rule-id-txt">规则ID:{{ ruleIds.join('、') }}</span>
      <span v-if="!tags.length && !ruleIds.length">{{ loaded ? '无活动' : unavailableText }}</span>
    </template>
    <span v-else-if="field === 'rewardResultText'">{{ resultText }}</span>
  </div>
</template>
<script>
import { orderActivityRewards } from '@/utils/orderActivityRewards'

const unique = values => [...new Set(values)]
const modeNames = { CASH: '现金', BALANCE: '余额', XIAODUBI: '零售价', GIFT: '学费' }
export default {
  props: { row: { type: Object, required: true }, field: { type: String, required: true } },
  computed: {
    failed() { return this.row.activityRewardLoadFailed === true },
    loaded() { return Array.isArray(this.row.activityRewardLogList) && this.row.activityRewardLogList.every(record => record && typeof record === 'object' && !Array.isArray(record)) },
    unavailableText() { return this.row.activityRewardLogList == null ? '活动信息未返回' : '活动信息无法读取' },
    rewards() { return this.loaded ? orderActivityRewards(this.row.activityRewardLogList) : [] },
    modeText() {
      return this.row.activityPayModeName || unique(this.rewards.map(row => row.mode)).join('、')
        || modeNames[this.row.activityPayMode] || this.row.activityPayMode || (this.loaded ? '无活动' : this.unavailableText)
    },
    ruleIds() {
      return Array.isArray(this.row.activityRuleIds) && this.row.activityRuleIds.length ? this.row.activityRuleIds
        : unique(this.rewards.map(row => row.conditionId).filter(id => Number(id) > 0))
    },
    tags() {
      return Array.isArray(this.row.activityTagList) && this.row.activityTagList.length ? this.row.activityTagList
        : unique(this.rewards.map(row => `${row.activityName}：${row.ruleText}`))
    },
    resultText() {
      return this.row.rewardResultText || this.rewards.map(row => `${row.activityName}（${row.status}）：${row.rewardText}`).join('；')
        || (this.loaded ? '无活动赠送记录' : this.unavailableText)
    }
  }
}
</script>
<style scoped>
.activity-read-failed { color: #c45656; }
</style>
